import { render, staticRenderFns } from "./ViberGroupIncoming.vue?vue&type=template&id=11a36220&"
import script from "./ViberGroupIncoming.vue?vue&type=script&lang=ts&"
export * from "./ViberGroupIncoming.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports